/*
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
*/

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly APP_VERSION_KEY = 'app_version';
  private readonly currentVersion = '1.0.0';

  constructor() {
    this.checkVersion();
  }

  private checkVersion(): void {
    const storedVersion = localStorage.getItem(this.APP_VERSION_KEY);

    if (storedVersion !== this.currentVersion) {
      console.log(`Version changed from ${storedVersion} to ${this.currentVersion}. Clearing cache...`);
      this.clearCache();
      localStorage.setItem(this.APP_VERSION_KEY, this.currentVersion);

      if (storedVersion !== null) {
        window.location.reload();
      }
    }
  }

  private clearCache(): void {
    const versionBackup = localStorage.getItem(this.APP_VERSION_KEY);
    localStorage.clear();
    if (versionBackup) {
      localStorage.setItem(this.APP_VERSION_KEY, versionBackup);
    }

    sessionStorage.clear();

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.update();
        });
      });

      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          caches.delete(cacheName);
        });
      });
    }
  }

  getCurrentVersion(): string {
    return this.currentVersion;
  }
}
